/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard Service
 * This is the API documentation of the Dashboard service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DataRequestResource } from './DataRequestResource';
import {
    DataRequestResourceFromJSON,
    DataRequestResourceFromJSONTyped,
    DataRequestResourceToJSON,
    DataRequestResourceToJSONTyped,
} from './DataRequestResource';

/**
 * 
 * @export
 * @interface GaugeDataRequest
 */
export interface GaugeDataRequest {
    /**
     * 
     * @type {Array<DataRequestResource>}
     * @memberof GaugeDataRequest
     */
    resources: Array<DataRequestResource>;
}

/**
 * Check if a given object implements the GaugeDataRequest interface.
 */
export function instanceOfGaugeDataRequest(value: object): value is GaugeDataRequest {
    if (!('resources' in value) || value['resources'] === undefined) return false;
    return true;
}

export function GaugeDataRequestFromJSON(json: any): GaugeDataRequest {
    return GaugeDataRequestFromJSONTyped(json, false);
}

export function GaugeDataRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): GaugeDataRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'resources': ((json['resources'] as Array<any>).map(DataRequestResourceFromJSON)),
    };
}

export function GaugeDataRequestToJSON(json: any): GaugeDataRequest {
    return GaugeDataRequestToJSONTyped(json, false);
}

export function GaugeDataRequestToJSONTyped(value?: GaugeDataRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'resources': ((value['resources'] as Array<any>).map(DataRequestResourceToJSON)),
    };
}

